<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="section" :class="themeColor">
      <Accordion type="freePanel" is-top-level="true">
        <template #body>
          <AccordionItem
            type="arrow"
            :is-open="isOpen"
            :is-disabled="isEditMode"
            :inverted="isDarkTheme"
          >
            <template #header>
              <heading
                :tagField="headingSizeField"
                desktopSize="size-3"
                mobileSize="size-4"
                class="title"
                :textField="titleField"
              />
            </template>
            <template #content>
              <div class="accordion-content">
                <template v-for="(component) in sectionPlaceholder">
                  <component :is="component" :key="component.name"/>
                </template>
              </div>
            </template>
          </AccordionItem>
        </template>
      </Accordion>
    </div>
  </sc-render>
</template>

<script>
import { Accordion, AccordionItem } from '@sohohouse/design-system'
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'

import get from '~/helpers/get'
import ThemeMixin from '~/mixins/theme'
import ScRender from '../sc-render'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'Section',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },

  components: {
    Accordion,
    AccordionItem,
    ScRender,
    Heading,
    ScText: Text,
    ScPlaceholder: Placeholder
  },

  mixins: [ThemeMixin],

  computed: {
    ...mapJssGetters(['isEditMode']),

    titleField () {
      return get(this.fields, 'title')
    },
    headingSizeField () {
      return get(this.fields, 'headingSize')
    },
    stateValue () {
      return get(this.fields, 'state.value')
    },
    isOpen () {
      return !!(this.stateValue === 'Expanded' || this.isEditMode)
    },
    themeColor () {
      return `theme-${this.theme.color}`.toLowerCase()
    }
  },
  withPlaceholder () {
    return {
      placeholders: [
        {
          placeholder: 'digital-house-section',
          computedPropName: 'sectionPlaceholder'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

.section {
  margin: 0 auto -#{$space-050};
  padding: 0 $space-050;

  &:first-child {
    margin-top: $space-090;
  }

  &:last-child {
    margin-bottom: $space-060;

    @include tablet {
      margin-bottom: $space-100;
      padding: 0;
    }
  }

  .title {
    padding: 0;
    margin: 0;
    font-weight: normal;
  }

  ::v-deep .accordion-block {
    margin: 0;
  }

  .accordion-content {
    @include font('050');
  }
}
</style>
